import {AttrsSchema, Component, ConfigOptions} from 'panel';

import {defineAndMakeJsxFactory} from 'common/util/jsx';
import {panel2react} from 'common/util/react';

import {template} from './template';
import css from './index.inline.styl';

interface LargeOptionAttrs {
  disabled?: boolean;
  focused?: boolean;
  selected?: boolean;
  theme?: string;
}

interface LargeOptionJsxProps {
  attrs: LargeOptionAttrs;
}

export class LargeOption extends Component<EmptyObj, LargeOptionAttrs> {
  static get attrsSchema(): AttrsSchema<LargeOptionAttrs> {
    return {
      ...super.attrsSchema,
      disabled: `boolean`,
      focused: `boolean`,
      selected: `boolean`,
      theme: {type: `string`, default: `primary`},
    };
  }

  get config(): ConfigOptions<EmptyObj> {
    return {
      useShadowDom: true,
      css,
      template,
      defaultState: {},
    };
  }
}

export const LargeOptionEl = defineAndMakeJsxFactory<LargeOptionJsxProps>(`mp-large-option`, LargeOption);
export const LargeOptionReact = panel2react<LargeOptionJsxProps>(`mp-large-option`, LargeOption);
